import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

const Blogs = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [list, setItems] = useState([]);
  const [single, setSingle] = useState(null);

  const types = [
    "Gözəllik Məsləhətləri",
    "Makyaj Trendləri",
    "Məhsuldan Necə İstifadə Etməli",
  ];
  const [selectedType, setSelectedType] = useState(types[0]);

  useEffect(() => {
    getSeoTags();
    getProducts();
  }, []);

  const getSeoTags = async () => {
    try {
      const response = await axios.get(
        "https://www.elzabeauty.az/elza/seoTagsBlogs.php"
      );
      const data = response.data.data || [];
      setSingle(data[0]);
    } catch (error) {
      console.error("Error fetching SEO tags:", error);
    }
  };

  const getProducts = async () => {
    try {
      const response = await axios.get(
        "https://www.elzabeauty.az/elza/blogs.php"
      );
      setItems(response.data.data);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  const getLocalizedField = (item, fieldBase) => {
    if (currentLanguage === "en")
      return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === "ru")
      return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase]; // default: az
  };

  const filteredItems = list.filter((item) => item.type === selectedType);

  return (
    <>
      {single && (
        <Helmet>
          <title>{getLocalizedField(single, "meta_tag_title")}</title>
          <meta
            name="description"
            content={getLocalizedField(single, "meta_tag_description")}
          />
          <meta
            name="keywords"
            content={getLocalizedField(single, "meta_tag_keywords")}
          />
        </Helmet>
      )}

      <div className="mt-8 md:mt-10">
        <div className="bg-[#EED2EF] h-[80px] md:h-[95px] flex items-center justify-center px-4">
          {/* Desktop buttons (md və daha böyük) */}
          <div className="hidden md:flex gap-5">
            {types.map((type) => (
              <button
                key={type}
                onClick={() => setSelectedType(type)}
                className={`px-5 py-2 rounded-lg h-[52px] transition-all ${
                  selectedType === type
                    ? "bg-white text-[#E497BB]"
                    : "text-secondColor"
                }`}
              >
                {t(type)}
              </button>
            ))}
          </div>

          {/* Mobile dropdown (md-dən kiçik) */}
          <div className="md:hidden w-full max-w-xs relative">
            <select
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              className="w-full h-[44px] px-4 py-2 rounded-lg text-secondColor appearance-none pr-10"
            >
              {types.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>

            {/* Custom dropdown icon */}
            <svg
              className="w-4 h-4 absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-secondColor"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </div>
        </div>
        <div className="max-w-containerSm md:max-w-container mx-auto">
          {/* Type Buttons */}

          {/* Blog List */}
          <div className="grid grid-cols-1 gap-6 md:gap-10 mt-8 md:mt-20 md:px-[30px]">
            {filteredItems.map((slide, index) => {
              const isEven = index % 2 === 0;

              return (
                <div
                  key={slide.id}
                  className={`flex flex-col md:flex-row gap-5 ${
                    !isEven ? "md:flex-row-reverse" : ""
                  }`}
                >
                  <div className="w-full md:w-[600px]">
                    <img
                      className="w-full h-[300px] md:h-[600px] object-cover rounded-lg"
                      src={`https://www.elzabeauty.az/elza/${slide.image}`}
                      alt={slide.title}
                    />
                  </div>
                  <div className="w-full md:w-[600px] flex items-center">
                    <div>
                      <p className="text-[#697586]">
                        {getLocalizedField(slide, "date")}
                      </p>
                      <p className="text-[#383838] text-[24px] md:text-[36px] font-semibold">
                        {getLocalizedField(slide, "title")}
                      </p>
                      <p className="text-[#404040] mt-5 md:mt-7">
                        {getLocalizedField(slide, "content")
                          .replace(/<[^>]*>/g, "")
                          .slice(0, 750)}
                        ...
                      </p>
                      <div className="mt-5 md:mt-7">
                        <a href={`/${currentLanguage}/blogs/${slide.id}`}>
                          <button className="bg-[#181D27] text-white h-[52px] w-full md:w-[200px] rounded-lg">
                            {t("Daha Çox")}
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Blogs;
